import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from '../common/Table';
import ConstElement from '../common/ConstElement';
import HasPermission from '../helper/user.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class EditTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            job: {work_start_date: null, work_end_date: null,},
            cities:[],
            prefs:[],
            helper:[],
            bigCategories:[],
            smallCategories:[],
            hasPermissionCancel:false,
            job_applys: [],
            hasAccepted: false,
        }
        this.saveData = this.saveData.bind(this);
        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.getJobById = this.getJobById.bind(this);
        this.getHelper = this.getHelper.bind(this);
        this.handleInptChange = this.handleInptChange.bind(this);
        this.handleInptChangeHelper = this.handleInptChangeHelper.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleChangeEditWorkStartDate = this.handleChangeEditWorkStartDate.bind(this);
        this.handleChangeEditWorkEndDate = this.handleChangeEditWorkEndDate.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.renderTicketImages = this.renderTicketImages.bind(this);
        this.renderHelperImages = this.renderHelperImages.bind(this);
        this.renderSupportAreas = this.renderSupportAreas.bind(this);
        this.processClassStatus = this.processClassStatus.bind(this);
        this.processStatus = this.processStatus.bind(this);
        this.getHelperData = this.getHelperData.bind(this);
        this.saveHelperData = this.saveHelperData.bind(this);
    }

    /**
     * Init data
     */
    componentWillMount() {
        HasPermission('/api/tickets/delete').then(permission => {this.setState({hasPermissionCancel: permission})});
        axios.get('/api/cities').then(response => {
            this.setState({
                cities: response.data
            });
        })
        axios.get('/api/prefs').then(response => {
            this.setState({
                prefs: response.data
            });
        })
        axios.get('/api/big-categories').then(response => {
            this.setState({
                bigCategories: response.data
            });
        })
        axios.get('/api/small-categories').then(response => {
            this.setState({
                smallCategories: response.data
            });
        })

        if (this.props.match.params.hasOwnProperty('id')) {
            this.getJobById();
        }
    }

    /**
     * Get job by id
     */
    getJobById() {
        const jobId = this.props.match.params.id
        axios.get('/api/tickets/' + jobId).then(response => {
            if (response.data) {
                this.setData(response.data);
            }
            this.getHelper();
        }).catch(() => {
            this.props.history.push('/_404');
        })
    }

    /**
     * Get job applys
     */
     getHelper() {
        let job = this.getData();
        console.log(job.helper_id);
        axios.get('/api/helpers/' + job.helper_id).then(response => {
            if (response.data) {
                this.setState({
                    helper: response.data
                })
            }
        });
    }

    /**
     * Process change work start date
     */
    handleChangeEditWorkStartDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_start_date'] = date;
        this.setState({job: jobData});
    }

    /**
     * Process change work end date
     */
    handleChangeEditWorkEndDate(date) {
        let jobData = Object.assign({}, this.state.job);
        jobData['work_end_date'] = date;
        this.setState({job: jobData});
    }


    /**
     * Set data of job
     * data: Object Job
     */
    setData(data) {
        this.setState({
            job: data
        })
    }

    /**
     * Get data of job
     */
    getData() {
        return this.state.job;
    }

    /**
     * Get data of job
     */
     getHelperData() {
        return this.state.helper;
    }

    /**
     * Listen change input
     * event: Object input
     */
    handleInptChange(event) {
        let jobData = Object.assign({}, this.state.job);
        jobData[event.target.name] = event.target.value;
        if (event.target.name === 'price_options') {
            if (event.target.value == 1) {
                jobData["included"] = 1;
                jobData["actual_expense_settlement"] = 0;
                jobData["consultation_possible"] = 0;
            } else if (event.target.value == 2) {
                jobData["included"] = 0;
                jobData["actual_expense_settlement"] = 1;
                jobData["consultation_possible"] = 0;
            } else if (event.target.value == 3) {
                jobData["included"] = 0;
                jobData["actual_expense_settlement"] = 0;
                jobData["consultation_possible"] = 1;
            }
        }

        if (event.target.type === 'checkbox') {
            if (event.target.checked) {
                jobData[event.target.name] = event.target.value;
            } else{
                jobData[event.target.name] = "";
            }
        }
        this.setState({job: jobData});
    }

    /**
     * Listen change input
     * event: Object input
     */
     handleInptChangeHelper(event) {
        let helperData = Object.assign({}, this.state.helper);
        helperData[event.target.name] = event.target.value;
        if (event.target.type === 'checkbox') {
            if (event.target.checked) {
                helperData[event.target.name] = event.target.value;
            } else{
                helperData[event.target.name] = "";
            }
        }
        this.setState({helper: helperData});
    }

    /**
     * Listen change status
     * event: Object input
     */
    handleStatusChange(index, event) {
        let jobApplies = this.state.job_applys;
        jobApplies[index]['status'] = parseInt(event.target.value);
        this.setState({job_applys: jobApplies})
    }

    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }

    /**
     * Call function save data from element parent
     */
    saveData() {
        let job = this.getData();
        //to top
        window.scrollTo(0, 0)
        if (job.hasOwnProperty('id')) {
            axios.post('/api/tickets/edit/' + job.id, job)
            .then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.getJobById();
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Call function save data from element parent
     */
    saveHelperData() {
        let helper = this.getHelperData();
        //to top
        window.scrollTo(0, 0)
        if (helper.hasOwnProperty('id')) {
            axios.post('/api/helpers/edit/' + helper.id, helper)
            .then(response => {
                if (response.data.success) {
                    toast.success(response.data.message);
                    this.getJobById();
                } else {
                    Object.keys(response.data.errors).map((key, i) => {
                            if($.isArray(response.data.errors[key])){
                                response.data.errors[key].map((child, i) => {
                                    toast.error(child)
                                })
                            } else {
                                toast.error(response.data.errors[key])
                            }
                        }
                    )
                }
            }).catch(error => {
                Object.keys(error.response.data.errors).map((key, i) => {
                        if($.isArray(error.response.data.errors[key])){
                            error.response.data.errors[key].map((child, i) => {
                                toast.error(child)
                            })
                        } else {
                            toast.error(error.response.data.errors[key])
                        }
                    }
                )
            })
        }
    }

    /**
     * Handle class with status
     */
    processClassStatus(status) {
        switch(status) {
            case 1:
                return "badge badge-info";
            case 2:
                return "badge badge-danger";
            case 3:
                return "badge badge-warning text-white";
            case 9:
                return "badge badge-dark";
            default:
                return "badge badge-secondary";
        }
    }

    /**
     * Handle show text with status
     */
    processStatus(status) {
        switch(status) {
            case 1:
                return "採用";
            case 2:
                return "不採用";
            case 3:
                return "欠勤";
            case 9:
                return "応募キャンセル";
            default:
                return "未決定";
        }
    }

    renderTicketImages() {
        let images = [
            '/img/detail_1.png',
        ];

        if (this.state.job.images_path && this.state.job.images_path.length) {
            images = this.state.job.images_path;
        }

        return (
            <div className="form-group row">
                <label className="col-sm-4 col-form-label text-right">チケット画像</label>
                <div className="col-sm-8">
                    {images.map((img, index) => {
                        return (
                            <img key={index} src={img} width="200" height="200" className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
                        );
                    })}
                </div>
            </div>
        );
    }

    renderHelperImages() {
        let images = [
            '/img/detail_1.png',
        ];

        if (this.state.helper.images_path && this.state.helper.images_path.length) {
            images = this.state.helper.images_path;
        }

        return (
            <div className="form-group row">
                <label className="col-sm-4 col-form-label text-right">助っ人画像</label>
                <div className="col-sm-8">
                    {images.map((img, index) => {
                        return (
                            <img key={index} src={img} width="200" height="200" className="imagePreview img-thumbnail ml-1 mr-1 mb-2" />
                        );
                    })}
                </div>
            </div>
        );
    }

    renderSupportAreas() {
        let supportAreas = this.state.helper.helper_support_areas;
        // console.log(supportAreas);
        if (supportAreas) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right"> 助っ人できそうなエリア</label>
                    <div className="col-sm-8">
                        {supportAreas.map((area, index) => {
                            return (
                                <p className="col-value text-left">{area.pref.name}{area.city.name}</p>
                            );
                        })}
                    </div>
                </div>
            );
        }
    }

    renderJobCareers() {

        let jobCareers = this.state.helper.helper_job_careers;
        // console.log(supportAreas);
        if (jobCareers) {
            return (
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">経歴など</label>
                    <div className="col-sm-8">
                        {jobCareers.map((jobCareer, index) => {
                            return (
                                <div>
                                    <p className="col-value text-left">{jobCareer.career_from}～{jobCareer.career_to}<br />{jobCareer.career_work_content}（{jobCareer.career_work_place}）</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            );
        }

    }


    render() {

        var weekDayList = [
            { check_name: "monday", text: "月曜日", start_name: "monday_start", end_name: "monday_end", check_val: this.state.helper.monday, start_val: moment(this.state.helper.monday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.monday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "tuesday", text: "火曜日", start_name: "tuesday_start", end_name: "tuesday_end", check_val: this.state.helper.tuesday, start_val: moment(this.state.helper.tuesday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.tuesday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "wednesday", text: "水曜日", start_name: "wednesday_start", end_name: "wednesday_end", check_val: this.state.helper.wednesday, start_val: moment(this.state.helper.wednesday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.wednesday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "thursday", text: "木曜日", start_name: "thursday_start", end_name: "thursday_end", check_val: this.state.helper.thursday, start_val: moment(this.state.helper.thursday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.thursday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "friday", text: "金曜日", start_name: "friday_start", end_name: "friday_end", check_val: this.state.helper.friday, start_val: moment(this.state.helper.friday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.friday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "saturday", text: "土曜日", start_name: "saturday_start", end_name: "saturday_end", check_val: this.state.helper.saturday, start_val: moment(this.state.helper.saturday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.saturday_end, 'HH:mm:ss').format('HH:mm') },
            { check_name: "sunday", text: "日曜日", start_name: "sunday_start", end_name: "sunday_end", check_val: this.state.helper.sunday, start_val: moment(this.state.helper.sunday_start, 'HH:mm:ss').format('HH:mm'), end_val: moment(this.state.helper.sunday_end, 'HH:mm:ss').format('HH:mm') },
        ];
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/tickets">チケット一覧</a></li>
                                <li className="breadcrumb-item active" aria-current="page">チケット編集</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <main id="main">
                    <div className="row justify-content-md-center">
                        <div className="col-sm-6">
                          <div className="card">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">チケット編集</h4></div>
                            <div className="card-body">
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">助っ人名</label>
                                    <div className="col-sm-8">
                                        {(this.state.job.first_last_name) ?
                                            <label className="col-value text-left text-primary"><a href={this.state.job.clientId ? "/accounts/edit/" + this.state.job.clientId : this.state.job.client.id}>{this.state.job.first_last_name ? this.state.job.first_last_name : ""}</a></label>
                                        : ''}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">タイトル</label>
                                    <div className="col-sm-8">
                                        <span className="col-value text-left">{this.state.job.categories_name}</span>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">公開状態</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} name="valid_flg" element="ticket.status" value={this.state.job.valid_flg ? this.state.job.valid_flg : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">時給</label>
                                    <div className="col-sm-8">
                                        <input type="text" onChange={this.handleInptChange} name="price" value={this.state.job.price ? parseInt(this.state.job.price) : 0} />　円/時間
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">交通費</label>
                                    <div className="col-sm-8">
                                        <input onChange={this.handleInptChange} value="1" type="radio" name="price_options" id="category_type1" checked={this.state.job.included == 1 ? 'checked' : ''} />
                                        <label htmlFor="category_type1" className="ml-1 mr-3">交通費込み</label>
                                        <input onChange={this.handleInptChange} value="2" type="radio" name="price_options" id="category_type2" checked={this.state.job.actual_expense_settlement == 1 ? 'checked' : ''} />
                                        <label htmlFor="category_type2" className="ml-1 mr-3">現地で実費精算可</label>
                                        <input onChange={this.handleInptChange} value="3" type="radio" name="price_options" id="category_type3" checked={this.state.job.consultation_possible == 1 ? 'checked' : ''} />
                                        <label htmlFor="category_type3" className="ml-1 mr-3">メッセージで相談可</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">アピールなど </label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="appeal_comment" value={this.state.job.appeal_comment ? this.state.job.appeal_comment : ''} className="form-control" rows="4"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">アピールなど（マスク処理前）</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="appeal_comment_without_mask" value={this.state.job.appeal_comment_without_mask ? this.state.job.appeal_comment_without_mask : ''} className="form-control" rows="4"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right"> 注意事項</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="important_points" value={this.state.job.important_points ? this.state.job.important_points : ''} className="form-control" rows="4"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right"> 注意事項（マスク処理前）</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="important_points_without_mask" value={this.state.job.important_points_without_mask ? this.state.job.important_points_without_mask : ''} className="form-control" rows="4"></textarea>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">作成日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.created_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">編集日</label>
                                    <div className="col-sm-8">
                                        <label className="col-value text-left">{moment(this.state.job.updated_at).format('YYYY-MM-DD HH:mm')}</label>
                                    </div>
                                </div>
                                {/* <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">値引額</label>
                                    <div className="col-sm-8">
                                        {
                                            React.createElement(
                                                'input',
                                                {type: 'text', onChange: this.handleInptChange, name: 'discount', value: this.state.job.discount || "", className: 'form-control'},
                                        )}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">トラブル区分</label>
                                    <div className="col-sm-8">
                                        <ConstElement onElementChange={this.handleInptChange} element="jobs.trouble_kb" value={this.state.job.trouble_kb ? this.state.job.trouble_kb : ''} />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-4 col-form-label text-right">メモ</label>
                                    <div className="col-sm-8">
                                        <textarea onChange={this.handleInptChange} name="remark" value={this.state.job.remark ? this.state.job.remark : ""}  className="form-control" rows="8"></textarea>
                                    </div>
                                </div> */}
                                {this.renderTicketImages()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card-footer">
                                    <div className="text-center">
                                        <button onClick={this.saveData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">チケット情報を更新</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-header p-4 border-bottom-0"><h4 className="mb-0">助っ人情報編集</h4></div>
                                <div className="card-body">
                                    <div className="list-group">
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">自己紹介コメント </label>
                                            <div className="col-sm-8">
                                                <textarea onChange={this.handleInptChangeHelper} name="self_introduction" value={this.state.helper.self_introduction ? this.state.helper.self_introduction : ''} className="form-control" rows="4"></textarea>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">自己紹介コメント（マスク処理前） </label>
                                            <div className="col-sm-8">
                                                <textarea onChange={this.handleInptChangeHelper} name="self_introduction_without_mask" value={this.state.helper.self_introduction_without_mask ? this.state.helper.self_introduction_without_mask : ''} className="form-control" rows="4"></textarea>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-sm-4 col-form-label text-right">助っ人しやすい曜日・<br />時間帯の目安</label>
                                                <div className="col-sm-8">
                                                    <div className="form-group">
                                                    {weekDayList.map((dataRow, i) => {
                                                    return <div className="row" style={{ height: 45 }}>
                                                            <label className="form-label"  style={{ marginTop: 5, marginBottom: 5 }} htmlFor="">{ dataRow.text }</label>
                                                            <div style={{ margin: 5 }}>
                                                                <input onChange={this.handleInptChangeHelper} type="checkbox" value="1" name={ dataRow.check_name } checked={dataRow.check_val ? true : false} className="form-checkbox" />
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <ConstElement onElementChange={this.handleInptChangeHelper} element="helper.work_start" name={dataRow.start_name} value={dataRow.start_val} />
                                                            </div>
                                                            <span className="form-label" >～</span>
                                                            <div className="col-sm-4">
                                                                <ConstElement onElementChange={this.handleInptChangeHelper} element="helper.work_end" name={dataRow.end_name} value={dataRow.end_val} />
                                                            </div>
                                                        </div>
                                                    })}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right"> 曜日・時間帯の補足コメント</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="reception_date_comment" value={this.state.helper.reception_date_comment ? this.state.helper.reception_date_comment : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right"> 曜日・時間帯の補足コメント（マスク処理前）</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="reception_date_comment_without_mask" value={this.state.helper.reception_date_comment_without_mask ? this.state.helper.reception_date_comment_without_mask : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            {this.renderSupportAreas()}
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right">  助っ人できそうなエリアの<br />補足コメント</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="area_comment" value={this.state.helper.area_comment ? this.state.helper.area_comment : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right">  助っ人できそうなエリアの<br />補足コメント（マスク処理前）</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="area_comment_without_mask" value={this.state.helper.area_comment_without_mask ? this.state.helper.area_comment_without_mask : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right">  資格など</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="qualifications" value={this.state.helper.qualifications ? this.state.helper.qualifications : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="col-sm-4 col-form-label text-right">  資格など（マスク処理前）</label>
                                                <div className="col-sm-8">
                                                    <textarea onChange={this.handleInptChangeHelper} name="qualifications_without_mask" value={this.state.helper.qualifications_without_mask ? this.state.helper.qualifications_without_mask : ''} className="form-control" rows="4"></textarea>
                                                </div>
                                            </div>
                                            {this.renderJobCareers()}
                                            {this.renderHelperImages()}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-footer">
                                        <div className="text-center">
                                            <button onClick={this.saveHelperData} className="btn btn-primary btn-radius btn-lg clearfix"><span className="size-inherit">助っ人情報を更新</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <ToastContainer />
            </React.Fragment>
        )
    }
}
